import { formatDate } from '@/lib/formats/formatDate'
import { formatTime } from '@/lib/formats/formatTime'

export const formatDateTime = (date: Date | string) => {
  return `${formatDate(date)} ${formatTime(date)}`
}
